/**
 * Lien d'invitation (FND-V050-050, SRF-ACC-014) : `/invitations#jeton=<secret>`.
 *
 * Le jeton voyage dans le FRAGMENT : le navigateur ne l'envoie jamais au serveur (ni journal
 * d'accès, ni en-tête `Referer`). Mais la connexion OIDC repart de `origin + pathname` et
 * perd le fragment : il est donc recueilli AVANT tout rendu (`main.tsx`), rangé dans le
 * `sessionStorage` de l'onglet (qui survit à l'aller-retour Keycloak) et effacé de la barre
 * d'adresse. Il n'est lu que par l'écran d'acceptation, et oublié dès qu'il a servi.
 */
const CLE = 'doit.invitation.jeton'
const MOTIF = /(?:^#|&)jeton=([^&]+)/

/** Recueille le jeton du fragment courant, s'il y en a un ; renvoie vrai si un jeton a été pris. */
export function capturerJetonInvitation(loc: Location = window.location, hist: History = window.history): boolean {
  const trouve = MOTIF.exec(loc.hash)
  if (!trouve) return false
  let jeton = ''
  try { jeton = decodeURIComponent(trouve[1] ?? '').trim() } catch { jeton = '' }
  if (!jeton) return false
  try { sessionStorage.setItem(CLE, jeton) } catch { return false }
  try { hist.replaceState(hist.state, '', loc.pathname + loc.search) } catch { /* barre d'adresse inchangée */ }
  return true
}

export function lireJetonInvitation(): string | null {
  try { return sessionStorage.getItem(CLE) } catch { return null }
}

export function oublierJetonInvitation(): void {
  try { sessionStorage.removeItem(CLE) } catch { /* rien à oublier */ }
}

/** Lien à transmettre à la personne invitée (affiché une seule fois, à la création). */
export function lienInvitation(jeton: string, origine: string = window.location.origin): string {
  return `${origine}/invitations#jeton=${encodeURIComponent(jeton)}`
}
